import React from 'react';
import { Card } from '@/lib/components/ui/card';

interface WeekDaysContentProps {
  selectedWeekDays: Set<number>;
  onWeekDayToggle: (day: number) => void;
  onWeekDayClick?: (day: number) => void;
}

const weekDays = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

export const WeekDaysContent: React.FC<WeekDaysContentProps> = ({ selectedWeekDays, onWeekDayToggle }) => {
  return (
    <div className="bg-gradient-to-br from-gray-50/30 via-white to-blue-50/20 p-8">
      <div className="animate-fade-in mb-8">
        <h2 className="bg-gradient-to-r from-gray-900 to-blue-900 bg-clip-text text-3xl font-bold text-transparent">
          Week Days
        </h2>
        <p className="animate-fade-in animation-delay-100 mt-2 text-gray-600">
          Choose which days of the week access is allowed
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {weekDays.map((day, index) => {
          const isSelected = selectedWeekDays.has(day.value);

          return (
            <Card
              key={day.value}
              className={`group animate-fade-in relative cursor-pointer overflow-hidden border-2 bg-white/60 p-6 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-black/5 ${
                isSelected
                  ? 'scale-[1.02] transform border-blue-500/50 bg-gradient-to-br from-blue-50 to-blue-100/50 shadow-lg shadow-blue-100'
                  : 'border-gray-200/50 hover:border-blue-300 hover:bg-blue-50/30'
              }`}
              style={{ animationDelay: `${index * 80 + 200}ms` }}
              onClick={() => onWeekDayToggle(day.value)}
            >
              {/* Selection Indicator */}
              {isSelected && (
                <div className="absolute top-3 right-3">
                  <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 shadow-sm">
                    <div className="h-2 w-2 rounded-full bg-blue-600"></div>
                  </div>
                </div>
              )}

              <div className="flex flex-col">
                <h3
                  className={`text-lg font-semibold transition-colors ${
                    isSelected ? 'text-gray-900' : 'text-gray-700 group-hover:text-gray-900'
                  }`}
                >
                  {day.label}
                </h3>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
